import React from 'react';
import { Modal, Button } from 'antd';

interface Props {
  open: boolean;
  onLoginAgain: () => void;
}

const IdleLogoutModal: React.FC<Props> = ({ open, onLoginAgain }) => {
  return (
    <Modal
      open={open}
      closable={false}
      maskClosable={false}
      footer={null}
      centered
      width={400}
    >
      <div style={{ textAlign: 'center', padding: '16px 0' }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>⏱️</div>
        <h3 style={{ marginBottom: 8 }}>Session Expired</h3>
        <p style={{ color: '#666', marginBottom: 24 }}>
          You have been inactive for 15 minutes. Please log in again to continue.
        </p>
        <Button type="primary" size="large" onClick={onLoginAgain} block>
          Login Again
        </Button>
      </div>
    </Modal>
  );
};

export default IdleLogoutModal;
